<!-- 水泵节能列表 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm">
            
        </div>
        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe>
        </lb-table>
    </div>
</template>

<script>
import Service from '@/api/Service'
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth } from '@/utils/utils'
import { FormatDate, FormatDateDay } from '@/utils/utils.js'

export default {
    name:  'energypumplist',
    data() {
        return {
            month: new Date().getMonth()+1,

            tableData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'pumps_name',
                        label: '名称',
                        sortable: true,
                    },
                    {
                        prop: 'addr',
                        label: 'addr',
                        sortable: true,
                    },
                    {
                        prop: 'before_power',
                        label: '改造前/kWh',
                    },
                    {
                        prop: 'after_power',
                        label: '改造后/kWh',
                    },
                    {
                        prop: 'deference_power',
                        label: '基数/kWh',
                         sortable: true,
                    },
                    {
                        prop: 'running_time',
                        label: '月时长/h',
                        sortable: true,
                    },
                    {
                        prop: 'initial_value',
                        label: '起始值',
                        sortable: true,
                    },
                    {
                        prop: 'current_value',
                        label: '结束值',
                        sortable: true,
                    },
                    {
                        prop: 'energy_conservation',
                        label: '节约电量/kWh'
                    },
                    {
                        prop: 'energy_conservation_fee',
                        label: '节约电费/元'
                    },
                    {
                        prop: 'pumps_divided_proportion',
                        label: '分成比例'
                    },
                    {
                        prop: 'pumps_divided_proportion_fee',
                        label: '分成费/元',
                        sortable: true,
                    },
                    {
                        label: '操作',
                        fixed: 'right',
                        render: (h, scope) => {
                        return (
                            <div>
                            <el-button
                                size="mini"
                                onClick={ () => { this.handleDetail(scope.$index, scope.row) } }>查看详情</el-button>
                            </div>
                        )
                        }
                    }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,
        };
    },

    components: { LbTable },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    created() {
        this.getData();
    },

    methods: {
        async getData() {
            let month = this.month
			let time = FormatDate('yyyy-MM-dd HH:mm:ss')
            let time_range = 'month'
            let res = await Service.getPumpsConservationByPIDMonthRange({month, time_range,time})
            if(res) {
                let list = res.pumps_detail.map(v=>{
                    return {
                        addr: v.running_time_addr,
                        pumps_name: v.pumps_name,
                        before_power: v.before_power,
                        after_power: v.after_power,
                        deference_power: v.deference_power,
                        running_time: v.running_time.value,
                        energy_conservation: v.energy_conservation.toFixed(2),
                        energy_conservation_fee:v.energy_conservation_fee.toFixed(2),
                        pumps_divided_proportion: res.pumps_divided_proportion.toFixed(2),
                        pumps_divided_proportion_fee: v.pumps_divided_proportion_fee.toFixed(2),
                        pumps_energy_conservation_id: v.pumps_energy_conservation_id,
                        current_value: v.running_time.current_value,
                        initial_value: v.running_time.initial_value,
                    }
                })
                function compare(addr){
                    return function(a,b){
                        var value1 = a[addr];
                        var value2 = b[addr];
                        return value1 - value2;
                    }
                }
                this.tableData.data = list.sort(compare("addr"))
            }
        },
        //   查询
        handleSearch() {
            this.getData();
        },
        handleDetail(index, row) {
            this.$router.push('/EnergyPumpList/EnergyPumpDetail/'+ row.pumps_energy_conservation_id)
        },
    }
}

</script>
<style lang='less' scoped>

</style>